import React from "react";
// import styles from "./Register.module.css"
const Register = () => {
  return <div>Register</div>;
};

export default Register;
